/* eslint-disable no-unused-vars */
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useEffect, useMemo, useState } from 'react'
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai'
import { BiFilterAlt, BiSortAlt2, BiSortDown, BiSortUp } from 'react-icons/bi'
import { useQuery } from 'react-query'
import { ButtonSubmit, Content, Title } from '../../GlobalStyle'
import apiPdv from '../../hooks/API_PDV'
import { Mask } from '../../hooks/Mask'
import BoxShadow from '../components/BoxShadowDiv'
import ComponentItem from '../components/Component'
import Header from '../components/Header'
import InputComponent from '../components/Input'
import { Toggle } from '../components/ToggleButton'
import {
  ActionsDiv,
  ColumnDiv,
  ContainerPopUp,
  FlexDiv,
  ModalPopUp,
  PdvImport,
  TableSales,
  Tag,
} from './style'

const DataSales = () => {
  const converterData = (data) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
    const novaData = new Date(data).toLocaleDateString('pt-BR', options)
    return novaData
  }
  const [openFilter, setOpenFilter] = useState()
  const [sorting, setSorting] = useState([])
  const [columnFilters, setColumnFilters] = useState([])
  const [filtering, setFiltering] = useState()

  const [shouldFetch, setShouldFetch] = useState(true) // sua condição aqui

  const {
    isLoading,
    data: ex = [
      {
        id: 10101,
        id_caixa: 140,
        id_operador: 18,
        id_loja: 18,
        comNota: 0,
        valor: '10',
        data: '2023-04-24T20:48:34.000Z',
        itens: [
          {
            id: 4,
            codigo_barras: '9439389',
            nome: 'Teste02',
            unidade: 'f',
            valor: '10',
            id_loja: 18,
            data: '2023-02-21T13:15:38.000Z',
            quantidade: 1,
          },
        ],
        methods: [],
      },
    ],
  } = useQuery(['dataSales'], () => apiPdv.getSales(), {
    enabled: shouldFetch,
  })

  const columnHelper = createColumnHelper()

  const data = useMemo(() => ex, [isLoading])

  const columns = [
    columnHelper.accessor('id', {
      header: 'N',
      cell: (info) => <span>{info.getValue()}</span>,
    }),
    columnHelper.accessor('data', {
      header: 'Data de venda',
      cell: (info) => <span>{converterData(info.getValue())}</span>,
    }),
    columnHelper.accessor('methods', {
      header: 'Formas de pagamento',
      cell: (info) =>
        info
          .getValue()
          .map((i) => (
            <ComponentItem
              margin={'0px 2px'}
              padding={'5px'}
              height={'auto'}
              invert
              key={i.id}
              title={i.nome}
            ></ComponentItem>
          )),
    }),

    columnHelper.accessor('valor', {
      header: 'Valor total',
      cell: (info) => <span className="greenText">{Mask.money(info.getValue())}</span>,
    }),
    columnHelper.accessor('comNota', {
      header: 'Nota fiscal',
      cell: (info) =>
        info.getValue() == 1 ? (
          <Tag green>
            <AiOutlineCheckCircle />
          </Tag>
        ) : (
          <Tag red>
            <AiOutlineCloseCircle />
          </Tag>
        ),
    }),
  ]

  const handleFilter = (event, id) => {
    event.stopPropagation()
    id == openFilter ? setOpenFilter(null) : setOpenFilter(id)
  }

  useEffect(() => {
    const handleClickOutsideModal = (event) => {
      if (openFilter && !event.target.closest('.modal')) {
        setOpenFilter(null)
      }
    }

    document.addEventListener('click', handleClickOutsideModal)
    return () => {
      document.removeEventListener('click', handleClickOutsideModal)
    }
  }, [openFilter])

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),

    state: {
      sorting,
      globalFilter: filtering,
      columnFilters,
    },
    onGlobalFilterChange: setFiltering,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
  })

  return (
    <Content>
      {' '}
      <Title>Dados de venda</Title>
      <BoxShadow>
        <Header title={'Vendas'} />
        <ActionsDiv>
          <ButtonSubmit width={'200px'} invert onClick={() => setColumnFilters([])}>
            <BiFilterAlt />
            Limpar
          </ButtonSubmit>
          <PdvImport>
            {' '}
            <p>Buscar do PDV</p>
            <Toggle toggled={shouldFetch} onClick={() => setShouldFetch(!shouldFetch)} />
          </PdvImport>

          <InputComponent
            width={'300px'}
            height={'38px'}
            value={filtering}
            onChange={(e) => setFiltering(e.target.value)}
            placeholder={'Pesquisar'}
          />
        </ActionsDiv>
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <ProgressSpinner size="6rem" />
          </div>
        ) : (
          <TableSales>
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.name}>
                  {headerGroup.headers.map((header) => (
                    <th key={header.name} className={header.column.getIsSorted() ? 'green' : null}>
                      <ColumnDiv>
                        <span onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}

                          {{
                            asc: <BiSortUp />,
                            desc: <BiSortDown />,
                          }[header.column.getIsSorted()] ?? <BiSortAlt2 />}

                          <BiFilterAlt
                            onClick={(event) => {
                              handleFilter(event, header.id)
                            }}
                          />
                        </span>

                        {header.column.getCanFilter() && (
                          <ContainerPopUp
                            className="modal"
                            style={{ display: header.id == openFilter ? 'block' : 'none' }}
                          >
                            <InputFilter
                              onChange={(value) => header.column.setFilterValue(value)}
                              close={() => setOpenFilter(null)}
                            />
                          </ContainerPopUp>
                        )}
                      </ColumnDiv>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {table?.getRowModel()?.rows?.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </TableSales>
        )}
      </BoxShadow>
    </Content>
  )
}
const InputFilter = ({ onChange, close }) => {
  const [value, setValue] = useState()
  const handle = () => {
    onChange(value)
    close()
  }
  return (
    <ModalPopUp>
      <InputComponent value={value} onChange={(e) => setValue(e.target.value)} />
      <FlexDiv>
        <ButtonSubmit invert> Limpar</ButtonSubmit>
        <ButtonSubmit onClick={handle}>Aplicar</ButtonSubmit>
      </FlexDiv>
    </ModalPopUp>
  )
}
export default DataSales
